// extracted by mini-css-extract-plugin
export var attachmentContainer = "_iq-0";
export var fileList = "_iq-2";
export var removeFileButton = "_iq-1";